import { render, staticRenderFns } from "./RolePermissionModal.vue?vue&type=template&id=3a9f8b6e"
import script from "./RolePermissionModal.vue?vue&type=script&lang=js"
export * from "./RolePermissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports